<template>
  <section id="notice">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @openNoticeView="openNoticeView"
      ></router-view>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/notice-manager/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <api-loading :show="loading"></api-loading>
    <!-- 查看通知详情 -->
    <ModalNoticeView :item="noticeView"></ModalNoticeView>
  </section>
</template>

<script>
import Header from "./header"; // 页面头部
import { pagination } from "@components/pagination.js"; // 分页
import ModalNoticeView from "./modal-notice-view";

export default {
  components: { Header, Pagination: pagination, ModalNoticeView },
  data() {
    return {
      leftSideStatus: true,
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("deposit-rowsPerPage"))
        ? parseInt(store.get("deposit-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      noticeView: {
        isShow: Symbol(),
        id: "",
      },
    };
  },
  watch: {
    $route: "gotoPage",
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取通知列表
     */
    getList() {
      this.loading = true;
      $.api_call(
        "api.Notice.getNoticeList",
        {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            this.items = r.Data.Results;
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
            $("html,body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    /**
     * 根据选择跳转到第几页
     */
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ params: { page: 1 } });
      if (page == 1) {
        this.getList();
      }
    },
    /**
     * 跳转到第几页
     */
    toPage(num) {
      let page = this.page;
      this.$router.push({ params: { page: num } });
      if (page == num) {
        this.getList();
      }
    },
    /**
     * 监听路由事件
     */
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    /**
     * 打开通知详情
     */
    openNoticeView(id) {
      this.noticeView.isShow = Symbol();
      this.noticeView.id = id;
      $("#modalNoticeView").modal("show");
    },
  },
};
</script>

<style lang='less' scoped>
</style>